import { kebabCase } from 'lodash';
import { pascalCase } from 'utils/pascal-case';
import { unreachable } from 'utils/unreachable';
import { BooleanField } from '../fields';

export enum BooleanFilterOperationType {
  IsTrue = 'IsTrue',
  IsFalse = 'IsFalse',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
}

export const BooleanFilterOperationTypes = [
  BooleanFilterOperationType.IsTrue,
  BooleanFilterOperationType.IsFalse,
  BooleanFilterOperationType.IsEmpty,
  BooleanFilterOperationType.IsNotEmpty,
];

export const isOptional = (type: BooleanFilterOperationType) =>
  type === BooleanFilterOperationType.IsEmpty ||
  type === BooleanFilterOperationType.IsNotEmpty;

export type BooleanFieldFilter = {
  field: BooleanField;
  type: BooleanFilterOperationType;
};

// NOTE:: Disabling until a rule is found
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isValid = (_: BooleanFieldFilter) => true;

const toString = (filter: BooleanFieldFilter): string => {
  const type = kebabCase(filter.type);

  switch (filter.type) {
    case BooleanFilterOperationType.IsEmpty:
    case BooleanFilterOperationType.IsNotEmpty:
    case BooleanFilterOperationType.IsTrue:
    case BooleanFilterOperationType.IsFalse:
      return type;
    default:
      return unreachable(filter.type);
  }
};

const parse = (value: string, field: BooleanField): BooleanFieldFilter => {
  const type = pascalCase(value) as BooleanFilterOperationType;

  switch (type) {
    case BooleanFilterOperationType.IsEmpty:
    case BooleanFilterOperationType.IsNotEmpty:
    case BooleanFilterOperationType.IsTrue:
    case BooleanFilterOperationType.IsFalse:
      return { field, type };
    default:
      return unreachable(type);
  }
};

export const BooleanFieldFilter = {
  isValid,
  toString,
  parse,
};
